export { default } from './PinAlternate'
